<template>
  <div class="md:max-w-full" v-if="company">
    <div class="mx-auto md:max-w-6xl">
      <BreadCrumb :companyDetails="company" />
    </div>
    <CompanyMetaData :companyDetails="company" />
    <DescriptionView
      :companyDetails="company"
      :properties="properties"
      :agents="agents"
    />
  </div>
</template>
<script>
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import { ref, onMounted } from "vue";
import axios from "axios";
import BreadCrumb from "@/features/find-broker/company/BreadCrumb.vue";
import DescriptionView from "@/features/find-broker/company/DescriptionView.vue";

import CompanyMetaData from "@/features/find-broker/company/CompanyMetaData.vue";
export default {
  components: {
    BreadCrumb,
    DescriptionView,
    CompanyMetaData,
  },
  setup() {
    const route = useRoute();
    const store = useStore();
    const base_url = store.state.baseUrl;
    const company = ref(null);
    const properties = ref(null);
    const agents = ref(null);

    onMounted(() => {
      axios
        .get(`${base_url}companies/${route.params.id}`)
        .then((response) => {
          company.value = response.data.data;
        })
        .catch((error) => console.log(error));

      axios
        .get(`${base_url}companies/${route.params.id}/properties`)
        .then((response) => {
          properties.value = response.data.data;
        })
        .catch((error) => console.log(error));

      axios
        .get(`${base_url}companies/${route.params.id}/agents`)
        .then((response) => {
          agents.value = response.data;
        })
        .catch((error) => console.log(error));
    });

    return {
      base_url,
      company,
      properties,
      agents,
    };
  },
};
</script>
